"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _emotion = require("emotion");

var _styleConsts = require("../utils/styleConsts");

var style = function style(theme, withBorder) {
  return (
    /*#__PURE__*/
    (0, _emotion.css)("display:block;box-sizing:border-box;width:100%;padding:0;border:0;background:transparent;resize:none;outline:none;font-size:", _styleConsts.font.size.large, ";", withBorder && "\n    border-radius: ".concat(_styleConsts.borderRadius, ";\n    padding: 4px;\n    border: 1px solid transparent;\n    \n    &:hover {\n      border-color: ").concat(theme.color.grey1, ";\n    }\n    \n    &:focus {\n      background-color: ").concat(theme.color.white, ";\n      border-color: ").concat(theme.color.accentClicked, ";\n    }\n  "))
  );
};

var _default = style;
exports.default = _default;